// utils/dayjs.ts
import dayjs from 'dayjs';

// 자주 쓰는 플러그인 등록
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import isBetween from 'dayjs/plugin/isBetween';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(isBetween);
dayjs.extend(customParseFormat);

// 기본 타임존 설정 (예: 서울)
dayjs.tz.setDefault('Asia/Seoul');

// 기본 내보내기
export default dayjs;

// 오늘 날짜 (YYYY-MM-DD)
export const today = () => dayjs().format('YYYY-MM-DD');

// 현재 시각 (YYYY-MM-DD HH:mm:ss)
export const now = () => dayjs().format('YYYY-MM-DD HH:mm:ss');

// 날짜 포맷 변환
export const formatDate = (date: string | Date | undefined, format = 'YYYY-MM-DD') => {
  if (!date) return '';
  return dayjs(date).format(format);
};

// 두 날짜 차이 (일 단위)
export const diffInDays = (a: string | Date, b: string | Date) => dayjs(a).diff(dayjs(b), 'day');

// 두 날짜 차이 (월 단위)
export const diffInMonths = (a: string | Date, b: string | Date) =>
  dayjs(a).diff(dayjs(b), 'month', true);

// n일 뒤 / n일 전
export const addDays = (date: string | Date, days: number) => dayjs(date).add(days, 'day').toDate();

export const subtractDays = (date: string | Date, days: number) =>
  dayjs(date).subtract(days, 'day').toDate();

// 상대 시간 (ex: "2일 전", "3시간 전")
export const fromNow = (date: string | Date) => dayjs(date).fromNow();

// 범위 안에 있는지 체크
export const isBetweenDates = (date: string | Date, start: string | Date, end: string | Date) =>
  dayjs(date).isBetween(start, end, null, '[]');

// 오늘 이전인지 체크
export const isBeforeToday = (date: string | Date | undefined) => {
  if (!date) return false;
  return dayjs(date).isBefore(dayjs(), 'day');
};

// 날짜 시간에서 시간만 추출 (HH:mm 형식)
// 예: "2025-12-10T13:13:13" -> "13:13"
// export const formatTime = (dateTime: string | Date | undefined) => {
//   if (!dateTime) return '';
//   return dayjs(dateTime).format('HH:mm');
// };

export const formatTime = (dateTime: string | Date | undefined) => {
  if (!dateTime) return '';
  const d = dayjs(dateTime);
  const hour = d.hour();
  const minute = d.minute();

  // 12시간 형식으로 변환
  const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  const ampm = hour < 12 ? '오전' : '오후';

  return `${ampm} ${hour12}시 ${minute}분`;
};

// 일주일 전부터 오늘까지의 날짜 범위
export const getDefaultDateRange = (unit: number = 7, mode: 'day' | 'month' = 'day') => {
  if (mode === 'day') {
    return {
      startDate: dayjs().subtract(unit, 'day').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
    };
  } else {
    return {
      startDate: dayjs().subtract(unit, 'month').format('YYYY-MM'),
      endDate: dayjs().format('YYYY-MM'),
    };
  }
};
export const getTomorrowDate = () => dayjs().add(1, 'day').format('YYYY-MM-DD');